import React from "react"
import { ListItem } from "@carrotfertility/carotene-core"

export const ModalListItem = ({ children }) => (
  <ListItem sx={{ alignItems: "flex-start" }}>
    <p style={{ paddingLeft: "6px", marginTop: "-6px" }}>{children}</p>
  </ListItem>
)

export const SubModalListItem = ({ children }) => (
  <ListItem sx={{ alignItems: "flex-start" }}>
    <p style={{ paddingLeft: "1rem", marginTop: "-6px" }}>{children}</p>
  </ListItem>
)
